import React from "react";
import _ from "lodash";
import { pbTypeReportKey } from "./AnatomyCstReportHelper";

const OPTIONS = [
  {
    label: "All",
    value: "ALL",
    key: pbTypeReportKey.ALL,
  },
  {
    label: "No PB",
    value: "NO_PB",
    key: pbTypeReportKey.NO_PB,
  },
  {
    label: "No PB key20",
    value: "NO_PB_KEY_20",
    key: pbTypeReportKey.NO_PB_KEY_20,
  },
];
class AnatomyNoPbSelector extends React.Component {
  constructor(props) {
    super(props);

    const { type, data } = this.props;
    const options = _.map(OPTIONS, (option) => {
      option.isNoData = this._getIsNoData(option.value);
      return option;
    });

    this.state = {
      options,
      type,
    };

    this.handleChanged = this.handleChanged.bind(this);
  }

  _getIsNoData(type) {
    const option = _.find(OPTIONS, { value: type });
    const isNoData = this.props.data[option.key].length === 0;
    return isNoData;
  }

  handleChanged(type) {
    this.setState({
      type,
    });
    this.props.handleNoPbTypeChanged({ type });
  }

  render() {
    const { options, type } = this.state;

    return (
      <div className="p-4">
        <div className="mb-1 font-semibold text-gray-700">Data Type:</div>
        <div className="flex items-center justify-start text-sm">
          <div>
            {options.map((option) => {
              return (
                <div key={option.value} className="inline-block">
                  <button
                    disabled={type === option.value || option.isNoData}
                    type="button"
                    className={`rounded mr-1 px-4 py-1 font-semibold text-gray-700 ${
                      type === option.value
                        ? "bg-blue-200"
                        : "bg-gray-100 hover:bg-gray-200 hover:text-gray-800"
                    } ${
                      option.isNoData ? "cursor-not-allowed opacity-50" : ""
                    }`}
                    onClick={() => this.handleChanged(option.value)}
                  >
                    {option.label}
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default AnatomyNoPbSelector;
